import React from "react";
import CSVImportRecordAtATimeWithProgress from "../../framework/util/forms/CSVImportRecordAtATimeWithProgress";
import PeopleStore from "../stores/PeopleStore";
import {useCreate} from "react-admin";
import Typography from "@material-ui/core/Typography";

const PeopleImport = () => {

    const [metrics, setMetrics] = React.useState();


    const ImportPerson = async (record) => {
        console.log(record.data);
        const person = record.data;
        try {
            await new PeopleStore().save(person);
            return Promise.resolve(person);
        } catch (error) {
            return Promise.reject(error);
        }

    }

    const onFinished = (metrics) => {
        setMetrics(metrics)
    }

    const successItems = [];
    if (metrics?.passed)
        metrics.passed.forEach(rec => successItems.push(
            (<li><Typography variant="caption" color="textSecondary" component="p">{rec.record.data.id}</Typography></li>)
            )
        );

    const success = successItems?.length ? (<div><Typography variant="h6" color="textSecondary" component="p">Success</Typography>
        <ul>{successItems}</ul>
    </div>)  : null;

    const failItems = [];
    if (metrics?.fail)
        metrics.fail.forEach(rec => failItems.push(
            (<li><Typography variant="caption" color="textSecondary" component="p">{rec.error.message} - {JSON.stringify(rec.record)}</Typography></li>)
            )
        );

    const fail = failItems?.length ? (<div><Typography variant="h6" component="p">Failures</Typography>
        <ul>{failItems}</ul>
    </div>) : null;

    const summary = metrics ? (
        <Typography variant="h5" component="p">{metrics?.perf.totalRecords} records processed in {metrics?.perf.seconds} seconds</Typography>
    ) : null;

    return (
        <div>
            <Typography variant="h5" component="p">Operator Bulk CSV Import</Typography>
            <br/>
            <Typography variant="body1" color="textSecondary" component="p">Import operators in bulk using a CSV file.<br/>
                An example CSV file can be generated from the list of operators, using the export button.<br/><br/>
                Note that previously existing records will not be overwritten.<br/><br/></Typography>
            <CSVImportRecordAtATimeWithProgress
                importRecordPromise={ImportPerson}
                onFinished={onFinished}>
            </CSVImportRecordAtATimeWithProgress>
            {summary}
            {fail}
            {success}
            <div>
                {/*<h3>Raw JSON</h3>*/}
                {/*{JSON.stringify(metrics)}*/}
            </div>
        </div>
    )

}

export default PeopleImport;